exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ReactModal__Body--open{overflow:hidden}.Overlay__overlay{z-index:100;background:rgba(0,0,0,.6);position:fixed;top:0;left:0;right:0;bottom:0}.Overlay__content{position:absolute;top:50%;left:50%;right:auto;bottom:auto;margin-right:-50%;transform:translate(-50%,-50%);border:1px solid #ccc;background:#fff;overflow:auto;-webkit-overflow-scrolling:touch;border-radius:4px;outline:none;padding:20px;overflow:hidden}.Overlay__content__close{display:none}@media screen and (max-width:767px){.Overlay__content{width:100%;height:100%;padding:0}.Overlay__content__close{cursor:pointer;display:block;color:#fff;text-align:center;line-height:50px;font-size:20px;position:fixed;top:0;left:0;width:100%;height:50px;z-index:1;background:#2d5da5;text-decoration:none}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../src/components/overlay/overlay.scss
// module id = 682
// module chunks = 0